// The API counts buckets out of 1000; the page shows and accepts percent with
// one decimal (one bucket = 0.1%).

export const BUCKETS = 1000;

export const bucketsToPercent = (buckets: number): number => Math.round(buckets) / 10;

export const formatPercent = (buckets: number): string => `${bucketsToPercent(buckets)}%`;

/** Null when the percent is not a whole number of buckets between 0 and 100%. */
export function percentToBuckets(percent: number): number | null {
  if (!Number.isFinite(percent)) return null;
  const buckets = percent * 10;
  const whole = Math.round(buckets);
  if (Math.abs(buckets - whole) > 1e-9) return null;
  if (whole < 0 || whole > BUCKETS) return null;
  return whole;
}
